
// import React, { useEffect, useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
// } from "react-router-dom";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import firebase from "firebase/compat/app";
// import "firebase/compat/messaging";
// import Home from "./components/Home";
// import Login from "./components/Login"
// import Logout from "./components/Logout";
// import OwnerAdd from "./components/tenant/OwnerAdd";
// import OwnerLogin from "./components/tenant/OwnerLogin";
// import TenantAdd from "./components/tenant/TenantAdd";
// import TenantRoutes from "./components/TenantRoutes";
// import CameraComponent from "./components/media/CameraComponent";
// import ImageUploadModal from "./components/media/ImageUploadModal";
// import SendEmail from "./components/SendEmail";
// import PrivacyPolicy from "./components/PrivacyPolicy";
// import TermsOfUse from "./components/TermsOfUse";
// import Download from "./components/Download";
// import { initializeApp } from "firebase/app";
// import firebaseConfig from "./firebase/firebaseConfig";
// import { getAnalytics } from "firebase/analytics";
// import PasswordResetForm from "./components/PasswordResetForm";
// import ResetPassword from "./components/auth/ResetPassword";
// import NotificationPrompt from './components/NotificationPrompt';
// import pushNotificationService from './services/pushNotificationService';
// import { getMe, getCurrentUserId } from './context/userContext';

// // Import error handling
// import ErrorBoundary from './components/ErrorBoundary';
// import globalErrorHandler from './utils/globalErrorHandler';

// // Import SplashScreen component
// import SplashScreen from './components/SplashScreen';

// // Initialize Firebase (with error handling)
// let app, analytics, messaging;

// try {
//   app = initializeApp(firebaseConfig);
//   analytics = getAnalytics(app);
  
//   if (!firebase.apps.length) {
//     firebase.initializeApp(firebaseConfig);
//   }
  
//   // Only initialize messaging if supported (not all iOS versions support it)
//   if ('Notification' in window && 'serviceWorker' in navigator) {
//     try {
//       messaging = getMessaging();
//     } catch (err) {
//       console.warn('⚠️  Firebase messaging not supported on this device:', err);
//       messaging = null;
//     }
//   } else {
//     console.warn('⚠️  Notifications or Service Worker not supported on this device');
//     messaging = null;
//   }
// } catch (error) {
//   console.error('❌ Firebase initialization error:', error);
//   globalErrorHandler.logError(error, { component: 'Firebase Init' });
// }

// function requestNotificationPermission() {
//   // Skip if messaging not available (e.g., older iOS)
//   if (!messaging) {
//     console.log('ℹ️  Push notifications not available on this device');
//     return;
//   }

//   if (!('Notification' in window)) {
//     console.log('ℹ️  Notifications not supported');
//     return;
//   }

//   Notification.requestPermission().then((permission) => {
//     if (permission === "granted") {
//       getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY })
//         .then((currentToken) => {
//           if (currentToken) {
//             console.log("✅ Notification Token:", currentToken);
//           } else {
//             console.log("ℹ️  No registration token available.");
//           }
//         })
//         .catch((err) => {
//           console.error("❌ Error getting token:", err);
//           globalErrorHandler.logError(err, { component: 'Notification Token' });
//         });

//       onMessage(messaging, (payload) => {
//         console.log("📬 Message received:", payload);
//         toast.info(`🔔 ${payload.notification.title}: ${payload.notification.body}`);
//       });
//     }
//   }).catch((err) => {
//     console.error("❌ Notification permission error:", err);
//     globalErrorHandler.logError(err, { component: 'Notification Permission' });
//   });
// }

// function App() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
  
//   // State to control splash screen display
//   // Shows splash on first app load, hides after animation or user click
//   const [showSplash, setShowSplash] = useState(() => {
//     // Check if splash has been shown in this session
//     const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');
//     return !hasSeenSplash;
//   });

//   // Initialize global error handler ONCE on app mount
//   useEffect(() => {
//     console.log('🚀 Initializing App...');
    
//     try {
//       // Initialize global error handler
//       globalErrorHandler.initialize();
      
//       // Log app start
//       console.log('📱 Device Info:', {
//         userAgent: navigator.userAgent,
//         platform: navigator.platform,
//         isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
//         isPWA: window.matchMedia('(display-mode: standalone)').matches
//       });
      
//     } catch (error) {
//       console.error('❌ Error initializing app:', error);
//       globalErrorHandler.logError(error, { component: 'App Init' });
//     }
    
//     // Request notification permission (with error handling)
//     try {
//       requestNotificationPermission();
//     } catch (error) {
//       console.error('❌ Error requesting notification permission:', error);
//       globalErrorHandler.logError(error, { component: 'Notification Init' });
//     }
//   }, []);

//   // Check if user is logged in using existing userContext utilities
//   useEffect(() => {
//     const checkLoginStatus = () => {
//       try {
//         const user = getMe();
//         const userId = getCurrentUserId();
//         setIsLoggedIn(!!(user && userId));
//       } catch (error) {
//         console.error('❌ Error checking login status:', error);
//         globalErrorHandler.logError(error, { component: 'Login Check' });
//       }
//     };

//     checkLoginStatus();
    
//     // Re-check on storage changes (when user logs in/out)
//     window.addEventListener('storage', checkLoginStatus);
    
//     return () => {
//       window.removeEventListener('storage', checkLoginStatus);
//     };
//   }, []);

//   // Initialize push notification service when user logs in
//   useEffect(() => {
//     if (isLoggedIn) {
//       pushNotificationService.initialize()
//         .then(initialized => {
//           if (initialized) {
//             console.log('✅ Push notification service ready');
//           }
//         })
//         .catch(err => {
//           console.error('❌ Push notification init error:', err);
//           globalErrorHandler.logError(err, { component: 'Push Service Init' });
//         });
//     }
//   }, [isLoggedIn]);
  
//   // Mark splash screen as seen when it's hidden
//   useEffect(() => {
//     if (!showSplash) {
//       sessionStorage.setItem('hasSeenSplash', 'true');
//     }
//   }, [showSplash]);

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prev) => !prev);
//   };

//   return (
//     <ErrorBoundary>
//       {/* Router must wrap everything including SplashScreen */}
//       <Router>
//         {/* Show splash screen on first load */}
//         {showSplash ? (
//           <SplashScreen onComplete={() => setShowSplash(false)} />
//         ) : (
//           <>
//             <div className="main">
//               <div className="main-content">
//                 {/* Show push notification prompt to logged-in users */}
//                 {isLoggedIn && <NotificationPrompt />}
                
//                 <Routes>
//                   <Route path="/" element={<Home />} />
//                   <Route path="/download" element={<Download />} />
//                   <Route path="/login" element={<Login />} />
//                   <Route path="/logout" element={<Logout />} />
//                   <Route path="/termsofuse" element={<TermsOfUse />} />
//                   <Route path="/privacypolicy" element={<PrivacyPolicy />} />
//                   <Route path="/owneradd" element={<OwnerAdd />} />
//                   <Route path="/tenantadd" element={<TenantAdd />} />
//                   <Route path="/ownerlogin" element={<OwnerLogin />} />
//                   <Route path="/:tenant/*" element={<TenantRoutes />} />
//                   <Route path="/camera" element={<CameraComponent />} />
//                   <Route path="/imageUpload" element={<ImageUploadModal />} />
//                   <Route path="/sendemail" element={<SendEmail />} />
//                   <Route path="/privacypolicy" element={<PrivacyPolicy />} />
//                   <Route path="/termsofuse" element={<TermsOfUse />} />
//                   <Route path="/reset-password" element={<PasswordResetForm />} />
//                   <Route path="/reset-password" element={<ResetPassword />} />
//                   <Route path="/reset-password/:token" element={<ResetPassword />} />
//                   <Route path="/:tenant/reset-password/:token" element={<ResetPassword />} />
//                 </Routes>
//               </div>
//             </div>
//             <ToastContainer />
//           </>
//         )}
//       </Router>
//     </ErrorBoundary>
//   );
// }

// export default App;


// =====================================================================
// Updated App.js with Internationalization Support
// Description: Main application component with i18n initialization
// Location: src/App.js
// =====================================================================
//
// IMPORTANT: This file REPLACES the existing App.js
// It adds i18n support while preserving ALL existing functionality
//
// Changes made:
// 1. Import i18n configuration (this initializes i18next)
// 2. Import and wrap app with I18nProvider
// 3. All existing functionality is preserved
// =====================================================================

import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import firebase from "firebase/compat/app";
import Home from "./components/Home";
import Login from "./components/Login"
import Logout from "./components/Logout";
import OwnerAdd from "./components/tenant/OwnerAdd";
import OwnerLogin from "./components/tenant/OwnerLogin";
import TenantAdd from "./components/tenant/TenantAdd";
import TenantRoutes from "./components/TenantRoutes";
import TermsAcceptanceGate from "./components/TermsAcceptanceGate";
import CameraComponent from "./components/media/CameraComponent";
import ImageUploadModal from "./components/media/ImageUploadModal";
import ExternalUploadPage from "./components/media/ExternalUploadPage";
import EventLandingPage from "./components/ticketing/EventLandingPage";
import OrderTicketsPage from "./components/ticketing/OrderTicketsPage";
import PublicEventPage from "./components/public/PublicEventPage";
import SendEmail from "./components/SendEmail";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import Download from "./components/Download";
import AboutMePage from "./components/AboutMePage";
import { initializeApp } from "firebase/app";
import firebaseConfig from "./firebase/firebaseConfig";
import { getAnalytics } from "firebase/analytics";
import PasswordResetForm from "./components/PasswordResetForm";
import ResetPassword from "./components/auth/ResetPassword";
import NotificationPrompt from './components/NotificationPrompt';
import pushNotificationService from './services/pushNotificationService';
import { getMe, getCurrentUserId } from './context/userContext';

// Import error handling
import ErrorBoundary from './components/ErrorBoundary';
import globalErrorHandler from './utils/globalErrorHandler';

// Import SplashScreen component
import SplashScreen from './components/SplashScreen';

// Session timeout hook (60-min inactivity)
import useSessionTimeout from './hooks/useSessionTimeout';

// NEW: Import i18n configuration and provider
import './i18n/config'; // This initializes i18next
import { I18nProvider } from './context/i18nContext';

// Initialize Firebase (analytics only — push notifications use Web Push API via pushNotificationService)
let app;

try {
  app = initializeApp(firebaseConfig);
  getAnalytics(app);

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  globalErrorHandler.logError(error, { component: 'Firebase Init' });
}

// Push notifications are now handled by pushNotificationService (Web Push API)

// Wrapper that activates session-timeout tracking inside the Router
function SessionTimeoutGuard() {
  useSessionTimeout();
  return null;
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  // State to control splash screen display
  // Shows splash on first app load, hides after animation or user click
  const [showSplash, setShowSplash] = useState(() => {
    // Check if splash has been shown in this session
    const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');
    // Public shared surfaces (ticketing landing, public event pages) skip the
    // splash entirely — a first-time visitor followed a link to see content.
    const p = window.location.pathname;
    if (/^\/(ev|e|tickets)\//.test(p)) return false;
    return !hasSeenSplash;
  });

  // Initialize global error handler ONCE on app mount
  useEffect(() => {
    console.log('🚀 Initializing App...');
    
    try {
      // Initialize global error handler
      globalErrorHandler.initialize();
      
      // Log app start
      console.log('📱 Device Info:', {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
        isPWA: window.matchMedia('(display-mode: standalone)').matches
      });
      
      // NEW: Log i18n initialization
      console.log('🌐 Internationalization initialized');
      
    } catch (error) {
      console.error('❌ Error initializing app:', error);
      globalErrorHandler.logError(error, { component: 'App Init' });
    }
    
    // Push notifications are initialized by pushNotificationService
  }, []);

  // Check if user is logged in using existing userContext utilities
  useEffect(() => {
    const checkLoginStatus = () => {
      try {
        const user = getMe();
        const userId = getCurrentUserId();
        setIsLoggedIn(!!(user && userId));
      } catch (error) {
        console.error('❌ Error checking login status:', error);
        globalErrorHandler.logError(error, { component: 'Login Check' });
      }
    };

    checkLoginStatus();
    
    // Re-check on storage changes (when user logs in/out)
    window.addEventListener('storage', checkLoginStatus);
    
    return () => {
      window.removeEventListener('storage', checkLoginStatus);
    };
  }, []);

  // Initialize push notification service when user logs in
  useEffect(() => {
    if (isLoggedIn) {
      pushNotificationService.initialize()
        .then(initialized => {
          if (initialized) {
            console.log('✅ Push notification service ready');
          }
        })
        .catch(err => {
          console.error('❌ Push notification init error:', err);
          globalErrorHandler.logError(err, { component: 'Push Service Init' });
        });
    }
  }, [isLoggedIn]);
  
  // Mark splash screen as seen when it's hidden
  useEffect(() => {
    if (!showSplash) {
      sessionStorage.setItem('hasSeenSplash', 'true');
    }
  }, [showSplash]);

  return (
    <ErrorBoundary>
      {/* NEW: Wrap entire app with I18nProvider */}
      <I18nProvider>
        {/* Router must wrap everything including SplashScreen */}
        <Router>
          {/* Show splash screen on first load */}
          {showSplash ? (
            <SplashScreen onComplete={() => setShowSplash(false)} />
          ) : (
            <>
              {/* Enforce 60-min inactivity timeout for logged-in users */}
              {isLoggedIn && <SessionTimeoutGuard />}

              <div className="main">
                <div className="main-content">
                  {/* Show push notification prompt to logged-in users */}
                  {isLoggedIn && <NotificationPrompt />}
                  
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/termsofuse" element={<TermsOfUse />} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                    <Route path="/owneradd" element={<OwnerAdd />} />
                    <Route path="/tenantadd" element={<TenantAdd />} />
                    <Route path="/ownerlogin" element={<OwnerLogin />} />
                    <Route path="/about" element={<Download />} />
                    <Route path="/about-me" element={<AboutMePage />} />
                    <Route path="/download" element={<Navigate to="/about" replace />} />
                    <Route path="/external-upload/:token" element={<ExternalUploadPage />} />
                    <Route path="/e/:tenantSlug/:eventId/:itemId" element={<EventLandingPage />} />
                    <Route path="/ev/:tenantSlug/:eventSlug" element={<PublicEventPage />} />
                    <Route path="/tickets/:accessToken" element={<OrderTicketsPage />} />
                    <Route path="/:tenant/*" element={<TermsAcceptanceGate><TenantRoutes /></TermsAcceptanceGate>} />
                    <Route path="/camera" element={<CameraComponent />} />
                    <Route path="/imageUpload" element={<ImageUploadModal />} />
                    <Route path="/sendemail" element={<SendEmail />} />
                    <Route path="/reset-password" element={<PasswordResetForm />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/:tenant/reset-password/:token" element={<ResetPassword />} />
                  </Routes>
                </div>
              </div>
              <ToastContainer />
            </>
          )}
        </Router>
      </I18nProvider>
    </ErrorBoundary>
  );
}

export default App;